<template>
  <div class="pa-20" ref="pagePdv">
    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item pointer" @click="$router.go(-1)">
          <b-icon icon="chevron-left"></b-icon>
        </div>
        <div class="level-item has-text-grid-1 has-text-weight-bold is-size-18px">
          <p class="has-text-left">Points de vente associés à l’enseigne {{enseigne.nomCommercial}}</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-notification type="is-white" :closable="false" class="pa-10">
            <p class="is-size-14px has-text-default">
              Total enseigne
              <strong class="pa-10">{{formatNombre(totalRecomEnseigne)}}</strong> HT
            </p>
          </b-notification>
        </div>
        <div class="level-item">
          <b-button type="is-color-button" class="is-size-14px has-text-weight-bold"
            @click="modalIsActive = !modalIsActive">
            Détail
          </b-button>
        </div>
      </div>
    </div>
    <div class="card" v-if="pdVentes.length && enseigne">
      <div class="card-content pa-10">
        <div class="media">
          <div class="media-left logo">
            <img class="logo" :src="logoClient.chemin">
          </div>
          <div class="media-content pa-10">
            <div class="content">
              <p class="has-text-default is-size-10px">
                <strong class="has-text-grid-1 is-size-7">
                  {{enseigne.nomCommercial}}
                </strong>
                <br>
                {{enseigne.adrComplet}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-12 mt-5" v-if="pdVentes.length">
      <div class="column is-6 pa-5" v-for="(pdv, i) in pdVentes" :key="i">
        <div class="card pointer" @click="accessRecom(pdv.previewLink)">
          <div class="card-content pa-10">
            <div class="content">
              <div class="media">
                <div class="media-left logo">
                  <img class="logo" :src="pdv.srcImg">
                </div>
                <div class="media-content pa-10">
                  <div class="content">
                    <p class="has-text-grid-1 is-size-7 mb-4">
                      {{pdv.libelle}}
                    </p>
                    <p class="has-text-default is-size-10px mb-4">
                      {{pdv.adresse.libelle}}
                    </p>
                    <p class="has-text-default is-size-10px">
                      <strong>{{pdv.panneaux.length}}</strong> panneaux (<strong>{{nbrePanneauxNew(pdv)}}</strong> nouveaux, <strong>{{nbrePanneauxOld(pdv)}}</strong> déjà sous contrat)
                    </p>
                  </div>
                </div>
                <div class="media-right pa-10">
                  <p class="is-size-14px">
                    <strong>{{formatNombre(pdv.montant)}}</strong> HT
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalCumulregies
    :modal-is-active="modalIsActive"
    :recoms="recomsEnseigne"
    :type="type"
    :enseignes="[{
      libelle : enseigne.nomCommercial,
      id : enseigne.num,
    }]"
    @modalIsClose="modalIsActive = $event"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { browseDetailClient, GetPiecesJointesAsync } from '@/api/recom';
import ModalCumulregies from '@/components/portailGroupe/modalCumulRegies';
import { formatNombre } from '@/services/general/general';

const Groupe = createNamespacedHelpers('groupe');

export default {
  components: {
    ModalCumulregies,
  },
  data() {
    return {
      pdVentes: [],
      enseigne: {},
      modalIsActive: false,
      recomsEnseigne: [],
      type: 'enseigne',
      logoClient: {},
    };
  },
  computed: {
    ...Groupe.mapState({
      recoms: 'recoms',
    }),
    totalRecomEnseigne() {
      if (!this.pdVentes.length) return 0;
      return this.pdVentes
        .map(pdv => pdv.montant)
        .reduce((a, b) => a + b);
    }
  },
  watch: {
    recoms: {
      handler (val) {
        if (!val.length) return;
        const loadingComponent = this.$buefy.loading.open({ container: this.$refs.pagePdv });
        this.recupererPdv();
        this.recupererRecoms();
        loadingComponent.close();
      },
      immediate: true,
    }
  },
  methods: {
    recupererPdv() {
      const id = this.$route.params.id;
      this.pdVentes = this.recoms.filter(recom => recom.data.pointDeVentes[0].idEnseigne === id)
        .map(el => ({
          ...el.data.pointDeVentes[0],
          previewLink: el.previewLink,
          montant: el.data.montant,
        })).sort((a, b) => {
            if (a.libelle < b.libelle) return -1;
            if (a.libelle > b.libelle) return 1;
            return 0;
        });
    },
    recupererRecoms() {
      const id = this.$route.params.id;
      this.recomsEnseigne = this.recoms.filter(recom => recom.data.pointDeVentes[0].idEnseigne === id);
    },
    async getEnseigne() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const id = this.$route.params.id;
        this.enseigne = (await browseDetailClient(id)).data;
        this.logoClient = (await GetPiecesJointesAsync(id)).data;
        loadingComponent.close();
      } catch (error) {
        loadingComponent.close();
      }
    },
    nbreRecom(id)  {
      const recom = this.recoms.filter(recom => recom.data.pointDeVentes[0].id === id);
      return recom.length;
    },
    nbrePanneauxNew(pdv)  {
      const panneaux = pdv.panneaux.filter(pan => pan.ancienPanneau.toUpperCase() === 'NON');
      return panneaux.length;
    },
    nbrePanneauxOld(pdv)  {
      const panneaux = pdv.panneaux.filter(pan => pan.ancienPanneau.toUpperCase() === 'OUI');
      return panneaux.length;
    },
    accessRecom(lien){
      window.open(lien);
    },
    formatNombre(val) {
      return formatNombre(val);
    },
  },
  async mounted() {
    await this.getEnseigne();
  }
}
</script>

<style>

</style>